import { useEffect, useState } from "react";
import deudaService from "../services/deudaService.tsx";
import { Deuda } from "../types/Deuda.tsx";
import { useAuth0 } from "@auth0/auth0-react";

export default function DeudaInfo({ socio_id, compact = false }: { socio_id: string; compact?: boolean }) {
  const [loading, setLoading] = useState<boolean>(false);
  const [deuda, setDeuda] = useState<Deuda | null>(null);
  const [showModal, setShowModal] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const getDeuda = async () => {
      setLoading(true);
      try {
        const response = await deudaService.getDeudaBySocioId(
          socio_id,
          getAccessTokenSilently
        );
        setDeuda(response);
      } catch (error) {
        console.error("Error al obtener la deuda:", error);
      } finally {
        setLoading(false);
      }
    };
    getDeuda();
  }, [socio_id, getAccessTokenSilently]);

  return (
    <>
      {loading ? (
        <p className="text-gray-600 mb-2 text-left">Cargando...</p>
      ) : compact ? (
        <p className="text-gray-600 mb-2 text-left">
          <a
            onClick={() => setShowModal(true)}
            className="text-blue-500 hover:underline cursor-pointer"
          >
            Ver detalle
          </a>
        </p>
      ) : (
        <p className="text-gray-600 mb-6 text-left">
          Deuda total: <strong>${deuda?.deuda_total ?? 0} </strong>
          <a
            onClick={() => setShowModal(true)}
            className="text-blue-500 hover:underline cursor-pointer ml-2"
          >
            Ver detalle
          </a>
        </p>
      )}

      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowModal(false)} // clic fuera = cerrar
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full"
            onClick={(e) => e.stopPropagation()} // clic dentro = NO cerrar
          >
            <h2 className="text-xl font-bold mb-4">Detalle de la deuda</h2>
            <p className="text-gray-700">
              <strong>Deuda de Socio:</strong>{" "}
              {deuda?.deuda_socio === 0 || deuda?.deuda_socio == null
                ? "Sin deuda"
                : `$${deuda.deuda_socio}`}
            </p>
            <p className="text-gray-700">
              <strong>Deuda de Caja de Seguridad:</strong>{" "}
              {deuda?.deuda_cofre === 0 || deuda?.deuda_cofre == null
                ? "Sin deuda"
                : `$${deuda.deuda_cofre}`}
            </p>
            <button
              onClick={() => setShowModal(false)}
              className="mt-6 text-sm text-blue-500 hover:underline"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
